// TEMPORARY dev harness — renders BuildActivity with sample plan + progress so
// Option B can be reviewed without a live build. Delete this file + its route.
import { BuildActivity } from '~/components/chat/BuildActivity';
import type { TaskItem, ProgressAnnotation } from '~/types/context';

const TASKS: TaskItem[] = [
  { id: '1', title: 'Plan layout & sections', status: 'done' },
  { id: '2', title: 'Research & gather assets', status: 'done' },
  { id: '3', title: 'Build hero, nav & sections', status: 'in-progress' },
  { id: '4', title: 'Wire up content & polish', status: 'pending' },
  { id: '5', title: 'Install, lint & verify', status: 'pending' },
  { id: '6', title: 'Start server & deploy', status: 'pending' },
];

// 42 granular tool calls; the last one is the live action shown under the active task.
const PROGRESS: ProgressAnnotation[] = [
  ...Array.from(
    { length: 41 },
    (_, i): ProgressAnnotation => ({
      type: 'progress',
      label: 'Editing file',
      status: 'complete',
      order: i,
      message: '',
    }),
  ),
  {
    type: 'progress',
    label: 'Reviewing UI quality',
    status: 'in-progress',
    order: 41,
    message: 'hero — contrast, rhythm',
  },
];

export default function DevBuildActivity() {
  return (
    <div className="w-full h-screen bg-page flex items-center justify-center p-6">
      <div className="w-full max-w-[560px]">
        {}
        <BuildActivity tasks={TASKS} progress={PROGRESS} handleStop={() => console.log('stop')} />
      </div>
    </div>
  );
}
